<template lang="pug">
  .accordionList-item(:class='customClassesItem', ref='item')
    .header(v-if='!injected', :class='customClassesHeader', :data-group='stayTopFixedGroup', @click="toggleActive") 
      slot(name='header') Header
    .accordionList-body(:class='{doNotFixFooter: injected}', v-if='!isLoading')
      slot(name='body') Body
</template>
<script>
import $ from 'jquery'
import _ from 'lodash'

export default {
  props: {
    initialActive: {
      type: Boolean,
      required: false,
      default: false
    },
    initialStayActive: {
      type: Boolean,
      required: false,
      default: false
    },
    injected: {
      type: Boolean,
      required: false,
      default: false
    },
    group: {
      type: String,
      required: false,
      default: 'default'
    },
    isLoading: {
      type: Boolean,
      required: false,
      default: false
    },
    classes: {
      type: Object,
      required: false,
      default: () => {}
    },
    classesHeader: {
      type: Object,
      required: false,
      default: () => {}
    }
  },
  data () {
    return {
      stayTopFixedGroup: this.group,
      uniqid: new Date().getTime() + Math.random(),
      active: this.initialActive,
      stayActive: this.initialStayActive,
      lastSelected: false
    }
  },
  mounted () {
    if (this.active) {
      this.updateExternalClick()
      this.loadContents()
    }
    if (this.stayActive) {
      this.active = true
    }
  },
  destroyed () {
    $('body').off('click.item-active-' + this.uniqid)
  },
  computed: {
    customClassesItem () {
      return _.assign({
        active: this.active,
        stayActive: this.stayActive,
        loading: this.isLoading,
        lastSelected: this.lastSelected
      }, this.classes)
    },
    customClassesHeader () {
      return _.assign({
        // stayTopFixed: this.active
      }, this.classesHeader)
    },
    accordionItem () { // needed for Accordion
      return this
    }
  },
  methods: {
    toggleActive ($event) {
      if ($event &&
          (
            ($event.originalEvent && $event.originalEvent.doNotDesactiveOnClick) ||
             $($event.target).closest('.doNotDesactiveOnClick').length > 0)
          ) {
        return
      }
      if (this.stayActive) {
        this.active = true
      } else {
        this.active = !this.active
        let elTop = $(this.$el).offset().top
        if (!this.active) {
          if (elTop < 50) {
            let scrollParent = $('#body')[0]
            // there are some visible items after this item ?
            // if (elTop + $(this.$el).height() < $($('#body')[0]).height()) {
            //   scrollParent.scrollTop = scrollParent.scrollTop - $(this.$el).height() + $header.height()
            // } else {
            if (elTop + $(this.$el).height() > 60) {
              scrollParent.scrollTop = scrollParent.scrollTop + elTop - 130
            }
          }
          let $header = $('.header', this.$el)
          $header.width('auto')
        }
      }
    },
    updateExternalClick () {
      if (this.active) {
        $('body').on('click.item-active-' + this.uniqid, (e) => {
          if ($(e.target).closest(this.$refs.item).length === 0) {
            this.toggleActive(e)
          }
        })
      } else {
        $('body').off('click.item-active-' + this.uniqid)
      }
    },
    loadContents () {
      if (this.isLoading && this.active) {
        this.$emit('load')
      }
    },
    updateLayout () {
      let parent = this.parentWithMethod('updateLayout')
      if (parent) {
        parent.updateLayout()
      }
    },
    assureItemIsVisible () {
      let parent = this.parentWithMethod('assureItemIsVisible')
      if (parent) {
        parent.assureItemIsVisible(this)
      }
    },
    parentWithMethod (method) {
      let parent = this.$parent
      while (parent != null && !parent[method]) {
        parent = parent.$parent
      }
      return parent
    },
    beTheLastSelected () {
      this.lastSelected = true
    },
    beNotTheLastSelected () {
      this.lastSelected = false
    },
    setStayActive (bool) {
      this.stayActive = bool
      if (this.stayActive) {
        this.active = true
      }
    }
  },
  watch: {
    active () {
      this.updateExternalClick()
      this.loadContents()
      this.$emit('toggleActive', this.active)
      if (this.active && !this.stayActive) {
        this.assureItemIsVisible()
        this.updateLayout()
        // updateLayout each 10ms to follow css animation (accordion item expands its width)
        let interval = setInterval(() => {
          this.updateLayout()
        }, 10)
        setTimeout(() => {
          clearInterval(interval)
        }, 400)
        let parent = this.parentWithMethod('setLastSelectedItem')
        if (parent) {
          parent.setLastSelectedItem(this)
        }
      }
    },
    isLoading () {
      if (this.isLoading) {
        this.loadContents()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// Accordion-Item.vue?59bcf4f8